import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { PRODUCTS_HREF, PRODUCT_GROUPS, ProductMenuItem } from './productMenuData';
function MobileSubItem({
  item
}: {
  item: ProductMenuItem;
}) {
  if (!item.href) {
    return <span aria-disabled="true" className="block py-2 pl-8 pr-4 text-sm font-normal text-brand-darkGold/60 cursor-not-allowed select-none break-words" data-id="element-144">
        {item.label}
      </span>;
  }
  return <a href={item.href} className="block py-2 pl-8 pr-4 text-sm font-normal text-brand-red hover:bg-brand-gray transition-colors break-words" data-id="element-145">
      {item.label}
    </a>;
}
export function ProductsMenuMobile() {
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState<string | null>(null);
  return <li className="border-b border-gray-200" data-id="element-146">
      <div className="flex items-center justify-between" data-id="element-147">
        <a href={PRODUCTS_HREF} className="flex-grow py-3 hover:text-brand-red transition-colors" data-id="element-148">
          PRODUCTS
        </a>
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label="Toggle products submenu" className="p-3 text-brand-charcoal" data-id="element-149">
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-150" />
        </button>
      </div>

      {open && <ul className="pb-2" data-id="element-151">
          {PRODUCT_GROUPS.map(grp => {
        const isOpen = openGroup === grp.label;
        return <li key={grp.label} className="border-t border-gray-100" data-id="element-152">
                <div className="flex items-center justify-between" data-id="element-153">
                  {grp.href ? <a href={grp.href} className="flex-grow py-2.5 pl-4 pr-2 text-sm font-semibold text-brand-charcoal hover:text-brand-red transition-colors break-words" data-id="element-154">
                      {grp.label}
                    </a> : <span className="flex-grow py-2.5 pl-4 pr-2 text-sm font-semibold text-brand-charcoal break-words" data-id="element-155">
                      {grp.label}
                    </span>}
                  <button type="button" onClick={() => setOpenGroup(g => g === grp.label ? null : grp.label)} aria-expanded={isOpen} aria-label={`Toggle ${grp.label} submenu`} className="p-2.5 text-brand-charcoal" data-id="element-156">
                    <ChevronRight className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-90' : ''}`} data-id="element-157" />
                  </button>
                </div>
                {isOpen && <ul className="bg-white" data-id="element-158">
                    {grp.items.map(item => <li key={item.label} data-id="element-159">
                        <MobileSubItem item={item} data-id="element-160" />
                      </li>)}
                  </ul>}
              </li>;
      })}
        </ul>}
    </li>;
}